// extracted by mini-css-extract-plugin
export default {"noResults":"noResults_noResults__jhyJv","title":"noResults_title__2upaQ"};